import { render, staticRenderFns } from "./Messagelist.vue?vue&type=template&id=366012ed&scoped=true&"
import script from "./Messagelist.vue?vue&type=script&lang=js&"
export * from "./Messagelist.vue?vue&type=script&lang=js&"
import style0 from "./Messagelist.vue?vue&type=style&index=0&id=366012ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366012ed",
  null
  
)

export default component.exports